import React from 'react';
import PrivacyPolicyContent from 'containers/PrivacyPolicyContent';
import PageDialogOverlay from 'components/PageDialogOverlay';

function PrivacyPolicyPage() {
  return (
    <PageDialogOverlay
      parentClassName="privacy-policy"
      headerTitle="Privacy Policy"
      pageTitle="Privacy Policy"
      backButtonText="Support"
      backLocation="/support"
      scrolling
    >
      <PrivacyPolicyContent />
    </PageDialogOverlay>
  );
}

export default PrivacyPolicyPage;
